import React, { useEffect, useState, useRef, useContext } from "react";
import {
  Nav,
  Navbar,
  Dropdown,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { NavLink, withRouter } from "react-router-dom";
import UserPhoto from "../user-photo/user-photo";
import {
  UserLogout,
  LoginContext,
} from "../../services/api/authentication-api";
import SearchButton from "../search-button/search-button";
import CreateButton from "../create-button-universal/create-button-universal";
import UseWindowDimensions from "../menu-actions/UseWindowDimensions";
import {
  GetAllNotificationByUserNew,
  MarkAllNotificationAsReadByUserNew,
  MarkNotificationAsReadAPI
} from "../../services/api/notification-api";
import { removeAuthCookie } from "../../services/api/api-util";
import { connect } from "react-redux";
import { selectUser, selectUserID } from "../../redux/user/user-selector";
import { createStructuredSelector } from "reselect";
import { clearAllFilters } from "../../redux/filters/filter-actions";
import { removeUser } from "../../redux/user/user-actions";
import { clearAllGroupBys, clearAllSorts } from "../../redux/sort/sort-actions";
import NoPermissionsPanel from "../no-permissions-panel/no-permissions-panel";
import UserDetailLabel from "../user-detail-label/user-detail-label";
import "./navigation-bar.scss";
import FluentUiIcon from "../../assets/fluent-ui-icon";
import { FluentBadge } from "../FluentUI/Fluent-Badge";
import LOGO from "../../assets/img/Logo/Logo.svg";
import LOGO_ICON from "../../assets/img/Logo/triyo-logo-36px.svg";
import { Tooltip as FluentTooltip} from "@fluentui/react-components";
const hideDashboardMenu = window["APP_SETTINGS"].HIDE_MENU_DASHBOARD;
const isLoginMVC = window["APP_SETTINGS"].REACT_APP_LOGIN_MVC === "TRUE";
const triyoVersion = window["APP_SETTINGS"].REACT_APP_VERSION || "";
const triyoDeployTs = window["APP_SETTINGS"].REACT_APP_DEPLOY_TS || "";

const NavigationBar = ({
  onLogout,
  history,
  user,
  removeUser,
  clearAllFilters,
  clearAllSorts,
  clearAllGroupBys,
}) => {
  const [notifications, setNotifications] = useState([]);
  const [unseenNotificationCount, setUnseenNotificationCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showNoPermissions, setShowNoPermissions] = useState(false);
  const [isLargeSize, setIsLargeSize] = useState(false);
  const [hideNavItems, setHideNavItems] = useState(false);
  const [currentModule, setCurrentModule] = useState("");
  const [isUserTooltipVisible, setIsUserTooltipVisible] = useState(false);
  const [isUserDropdownVisible, setIsUserDropdownVisible] = useState(false);
  const [showHamburger, setShowHamburger] = useState(false);

  const isSelfServe = window["APP_SETTINGS"].REACT_APP_SELFSERVE_USER === "TRUE";

  const { width } = UseWindowDimensions();
  let checkWidth = width > 500;
  const emptyNotificationData = [
    {
      description: "No Notifications",
      link: "",
      author: null,
      time: null,
      section: null,
      notificationId: 0,
      senderId: 0,
      isRead: 0,
      profileImage: "/Assets/Images/no-photo.jpg",
    },
  ];

  useEffect(() => {
    let newModule = "";

    if (history.location.pathname.includes("admin")) {
      newModule = "admin";
    } else if (history.location.pathname.includes("projects")) {
      newModule = "projects";
    } else if (history.location.pathname.includes("task")) {
      newModule = "tasks";
    } else if (history.location.pathname.includes("dashboard")) {
      newModule = "dashboard";
    }

    if (newModule !== currentModule && currentModule !== "") {
      clearAllGroupBys();
      clearAllSorts();
      clearAllFilters();
    }
    setCurrentModule(newModule);
  }, [history.location.pathname]);

  let wrapperRef = useRef();
  const userID = useContext(LoginContext);
  const labels = userID?.currentUser?.objectLabels;

  useEffect(() => {
    const cleanup = () => {
      window.removeEventListener("resize", resizeMountedNavbar);
    };

    window.addEventListener("resize", resizeMountedNavbar);
    return cleanup;
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef && !wrapperRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    const cleanup = () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    return cleanup;
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && showHamburger) {
        setShowHamburger(false);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [showHamburger]);

  useEffect(() => {
    resizeMountedNavbar();
    loadNotifications();
  }, []);

  const resizeMountedNavbar = () => {
    const isLarge = window.innerWidth > 1440;
    setIsLargeSize(isLarge);
  };

  const loadNotifications = async () => {
    let notificationFilter = {
      userId: userID,
      pageSize: 10,
      pageNumber: 1,
      sortDesc: true,
      sortBy: "",
      filters: [],
    };

    let apiResponse = await GetAllNotificationByUserNew({
      pageSize: notificationFilter.pageSize,
      pageNumber: notificationFilter.pageNumber,
      filters: notificationFilter.filters,
    });
    let apiResponseData = apiResponse.data;
    if (apiResponseData.Notifications === null) {
      apiResponseData.Notifications = emptyNotificationData;
    }
    setNotifications(apiResponseData.Notifications);
    setUnseenNotificationCount(apiResponse.data.UnseenNotificationCount);
  };

  const markAllAsRead = async () => {
    await MarkAllNotificationAsReadByUserNew();
    let newNotifications = notifications.map((notification) => ({
      ...notification,
      isRead: 1,
    }));

    setNotifications(newNotifications);
    setUnseenNotificationCount(0);
    setShowNotifications(false);
  };

  const handleRoutingOnClick = async (link) => {
    try {
      if (link === "/profile" || link === "/settings") {
        history.push(link);
      }
    } catch (error) {
      console.log("Error logging out API");
      console.log(error);
    };
  };

  const handleOnLogout = async () => {
    try {
      removeAuthCookie();
      removeAuthCookie();
      await UserLogout().then(
        async (result) => {
          console.log("API Logged out");
          console.log(result);
          removeAuthCookie();
          await continueLogoutFlow();
        },
        async (error) => {
          console.log("Error logging out API");
          console.log(error);
          removeAuthCookie();
          await continueLogoutFlow();
        }
      );
    } catch (error) {
      console.log("Error logging out API");
      console.log(error);
      removeAuthCookie();
      await continueLogoutFlow();
    }
  };

  const continueLogoutFlow = async () => {
    localStorage.setItem("doughnut_sort", "Status");
    localStorage.setItem("task_sort", "upcoming due dates");
    localStorage.setItem("lineGraph_sort", "Last 7 Days");
    localStorage.setItem("project_sort", "Upcoming Due Dates");
    localStorage.setItem("tmpTriyoToken", "All");
    localStorage.setItem("lineGraph_sort_start", "undefined");
    localStorage.setItem("lineGraph_sort_end", "undefined");

    await onLogout();
    await removeUser();
    if (!isLoginMVC) {
      removeAuthCookie();
      history.push("/login");
    } else {
      removeAuthCookie();
    }
  };

  const notificationLink = async (notification) => {
    let result;
    try {
      result = await MarkNotificationAsReadAPI(notification.notificationId);
    } catch (error) {
      console.error("Error marking notification as read:", error);
      return;
    }
    if (result.status === 200) {
      let newNotifications = notifications.map((noti) => ({
        ...noti,
        isRead:
          notification.notificationId == noti.notificationId ? 1 : noti.isRead,
      }));

      setNotifications(newNotifications);
      setUnseenNotificationCount(unseenNotificationCount - 1);
      setShowNotifications(false);

      if (notification.link.includes("std")) {
        let location = {
          pathname: notification.link,
          state: {
            buttons: [],
            approve: true,
            decline: true,
            cancel: false,
          },
        };
        history.push(location);
        return;
      }
      history.push(notification.link);
    }
  };

  const getNotificationClass = (isRead, className) => {
    if (!isRead) return className;

    return "";
  };

  const HandleAddOnClick = () => {
    window.open(
      "https://appsource.microsoft.com/en-us/product/office/WA200003574?src=office",
      "_blank",
      "noopener"
    );
  };

  const hidePermission = () => {
    setShowNoPermissions(false);
  };

  return (
    <>
      <Navbar className="top-nav nav-bar nav-bar-container">
        <div className="flex-container">
          <Navbar.Brand href="/">
            <img
              src={checkWidth ? LOGO : LOGO_ICON}
              alt="TRIYO"
              className={checkWidth ? "triyo-logo" : "triyo-logo-icon"}
            />
          </Navbar.Brand>

          {showNoPermissions ? (
            <NoPermissionsPanel
              show={showNoPermissions}
              onHide={hidePermission}
              message={"You don't have permission to use this feature"}
            />
          ) : (
            <></>
          )}

          {user && (
            <>
              <div
                className={
                  "nav-center" + (checkWidth && hideNavItems ? "-hidden" : "")
                }
              >
                <Nav variant="pills">
                  {(!hideDashboardMenu || hideDashboardMenu === "FALSE") && (
                    <Nav.Item>
                      <NavLink className="nav-link" to="/dashboard">
                        <FluentUiIcon
                          name={"DataUsageRegular"}
                          color={"#616161"}
                          size={16}
                        />
                        Dashboard
                      </NavLink>
                    </Nav.Item>
                  )}
                  <Nav.Item>
                    <NavLink className="nav-link" to="/projects">
                      <FluentUiIcon
                        name={"FolderRegular"}
                        color={"#616161"}
                        size={16}
                      />
                      {labels?.ProjectPlural ?? "Projects"}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item>
                    <NavLink className="nav-link" to="/tasks">
                      <FluentUiIcon
                        name={"ClipboardTaskRegular"}
                        color={"#616161"}
                        size={16}
                      />
                      {labels?.TaskPlural ?? "Tasks"}
                    </NavLink>
                  </Nav.Item>
                  {(user.profile.isSuperAdminRole ||
                    user.profile.isAdminRole) && (
                      <Nav.Item>
                        <NavLink className="nav-link" to={"/admin"}>
                          <FluentUiIcon
                            name={"ToolboxRegular"}
                            color={"#616161"}
                            size={16}
                          />
                          Admin
                        </NavLink>
                      </Nav.Item>
                    )}                  
                </Nav>
              </div>
              <div className="navbar-right">
                <SearchButton setHideNavItems={setHideNavItems} />
                <div className={"addin-btn-" + (isSelfServe ? "show" : "hidden")}>
                  <div
                    className="addin-button-style"
                    onClick={HandleAddOnClick}
                  ></div>
                </div>
                <CreateButton />
                <div className="notification-logo">
                  {unseenNotificationCount > 0 ? (
                    <div
                      className={
                        "notification-number "                        
                      }
                    >
                      {/* Removed by Product Team */}
                      {/* {unseenNotificationCount > 999
                        ? 999 + "+"
                        : unseenNotificationCount} */}
                    </div>
                  ) : (
                    <></>
                  )}
                  <Dropdown
                    ref={wrapperRef}
                    show={showNotifications}
                    onClick={() => {
                      setShowNotifications(!showNotifications);
                    }}
                    id="notification-button"
                  >
                    <Dropdown.Toggle id="notification-button-clickable">
                      <FluentUiIcon name="Alert20Regular" size={20} color="#616161" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu id="notification-dropdown">
                      <div className="notification-title-container">
                        <div className="notification-title">Notifications</div>
                        <Button className="mark-all-btn" onClick={markAllAsRead}>
                          Mark All as Read
                        </Button>
                      </div>
                      <div className="notification-scroll-container">
                        {notifications.map((notification) => {
                          return (
                            <Dropdown.Item
                              className={
                                getNotificationClass(
                                  notification.isRead,
                                  "notification-read "
                                ) + "notification-item"
                              }
                              onClick={(e) => notificationLink(notification)}
                              key={notification.description}
                            >
                              <div className="user-picture-container">
                                <UserPhoto
                                  key={notification.author}
                                  // profileImage={notification.author}
                                  name={notification.author}
                                  size={40}
                                  color="brand"
                                ></UserPhoto>
                              </div>
                              <div className="notification-item-description">
                                <div className={"notification-author " + getNotificationClass(notification.isRead, "notification-author--unread")}>
                                  {notification.author}
                                </div>
                                <div className="notification-item-description-text">
                                  {notification.description}
                                </div>
                              </div>
                            </Dropdown.Item>
                          );
                        })}{" "}
                      </div>
                      <div className="notification-link-container">
                        <NavLink
                          className="notification-all-link"
                          to={"/notifications"}
                          onClick={() => setShowNotifications(false)}
                        >
                          Show all Notifications
                        </NavLink>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="current-user">
                  <Dropdown
                    onToggle={(toggle) => setIsUserDropdownVisible(toggle)}
                  >
                    <Dropdown.Toggle id="dropdown-basic">
                      <OverlayTrigger
                        placement="bottom-end"
                        show={isUserTooltipVisible && !isUserDropdownVisible}
                        trigger={["hover", "hover"]}
                        onToggle={(toggle) => setIsUserTooltipVisible(toggle)}
                        overlay={
                          <Tooltip>
                            {user.profile.userNameFull}
                            <br />
                            {user.profile.strRole}
                          </Tooltip>
                        }
                      >
                        <UserPhoto
                          key={user.userNameFull}
                          photo={user.profile.profileImage}
                          name={user.profile.userNameFull}
                          color="brand"
                        ></UserPhoto>
                      </OverlayTrigger>
                    </Dropdown.Toggle>
                    <Dropdown.Menu id="profile-dropdown">
                      <Dropdown.Item
                        className="profile-action-item"
                        onClick={() => handleRoutingOnClick("/profile")}
                      >
                        <FluentUiIcon name="PersonRegular" size={16} color="#242424" />
                        <span>View Profile</span>
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="profile-action-item"
                        onClick={() => handleRoutingOnClick("/settings")}
                      >
                        <FluentUiIcon name="SettingsRegular" size={16} color="#242424" />
                        <span>User Settings</span>
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="profile-action-item"
                        onClick={async () => await handleOnLogout()}
                      >
                        <FluentUiIcon name="ArrowExitRegular" size={16} color="#242424" />
                        <span>Log Out</span>
                      </Dropdown.Item>
                      <div className="profile-dropdown-divider" />
                      <div className="profile-user">
                        <div className="profile-user-card">
                          <div className="profile-user-card-header">
                            <UserPhoto
                              photo={user.profile.profileImage}
                              name={user.profile.userNameFull}
                              size={40}
                              color="brand"
                            />
                            <div className="profile-user-card-info">
                              <div className="profile-user-badges">
                                {user.profile.strCompany && (
                                  <FluentBadge
                                    text={user.profile.strCompany}
                                    appearance="filled"
                                    color="important"
                                    shape="rectangle"
                                    size="medium"
                                  />
                                )}
                                {user.profile.isSuperAdminRole && (
                                  <FluentBadge
                                    text="Super Admin"
                                    appearance="outline"
                                    color="important"
                                    shape="rectangle"
                                    size="medium"
                                  />
                                )}
                                {!user.profile.isSuperAdminRole && user.profile.isAdminRole && (
                                  <FluentBadge
                                    text="Admin"
                                    appearance="outline"
                                    color="important"
                                    shape="rectangle"
                                    size="medium"
                                  />
                                )}
                              </div>
                              <div className="profile-user-name">{user.profile.userNameFull}</div>
                              {user.profile.strRole && (
                                <div className="profile-user-dept">{user.profile.strRole}</div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="profile-dropdown-divider help" />
                        <div className="profile-dropdown-footer">
                          <a
                            href="mailto:support@triyo.io"
                            className="profile-get-help"
                            rel="noopener noreferrer"
                          >
                            <FluentUiIcon name="QuestionCircleRegular" size={16} color="#0E75BB" />
                            <span>Get Help</span>
                          </a>
                          <span className="profile-version">
                            
                            {triyoDeployTs?.length > 0
                              ? (
                                <FluentTooltip content={triyoDeployTs} relationship="label">
                                     <span>TRIYO {triyoVersion}</span>
                                </FluentTooltip>
                              )
                              : `TRIYO ${triyoVersion}`
                            }
                          </span>
                        </div>
                      </div>

                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                {!checkWidth && (
                  <button
                    className="hamburger-btn"
                    onClick={() => setShowHamburger(!showHamburger)}
                    aria-label="Navigation menu"
                  >
                    <FluentUiIcon
                      name={showHamburger ? "DismissRegular" : "NavigationRegular"}
                      size={20}
                      color="#616161"
                    />
                  </button>
                )}
              </div>
              {!checkWidth && showHamburger && (
                <div className="hamburger-menu-panel">
                  {(!hideDashboardMenu || hideDashboardMenu === "FALSE") && (
                    <NavLink
                      className="hamburger-nav-link"
                      to="/dashboard"
                      onClick={() => setShowHamburger(false)}
                    >
                      <FluentUiIcon name="DataUsageRegular" size={16} color="#616161" />
                      Dashboard
                    </NavLink>
                  )}
                  <NavLink
                    className="hamburger-nav-link"
                    to="/projects"
                    onClick={() => setShowHamburger(false)}
                  >
                    <FluentUiIcon name="FolderRegular" size={16} color="#616161" />
                    {labels?.ProjectPlural ?? "Projects"}
                  </NavLink>
                  <NavLink
                    className="hamburger-nav-link"
                    to="/tasks"
                    onClick={() => setShowHamburger(false)}
                  >
                    <FluentUiIcon name="ClipboardTaskRegular" size={16} color="#616161" />
                    {labels?.TaskPlural ?? "Tasks"}
                  </NavLink>
                  {(user.profile.isSuperAdminRole || user.profile.isAdminRole) && (
                    <NavLink
                      className="hamburger-nav-link"
                      to="/admin"
                      onClick={() => setShowHamburger(false)}
                    >
                      <FluentUiIcon name="ToolboxRegular" size={16} color="#616161" />
                      Admin
                    </NavLink>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </Navbar>
      <UserDetailLabel />
    </>
  );
};

const mapState = createStructuredSelector({
  user: selectUser,
  userID: selectUserID,
});

const mapDispatch = (dispatch) => ({
  clearAllFilters: () => dispatch(clearAllFilters()),
  clearAllSorts: () => dispatch(clearAllSorts()),
  clearAllGroupBys: () => dispatch(clearAllGroupBys()),
  removeUser: () => dispatch(removeUser()),
});

// NavigationBar.contextType = LoginContext;
export default withRouter(connect(mapState, mapDispatch)(NavigationBar));
